import { notification } from 'antd';
import type { BellSchedule } from './types';
import { appApi } from '../api-instance';

export const getBellSchedules = (): Promise<BellSchedule[]> => {
  return appApi
    .get('/bell-schedules')
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось загрузить расписание звонков' });
      throw error;
    });
};

export const createBellSchedule = (bellSchedule: BellSchedule): Promise<void> => {
  return appApi
    .post('/bell-schedules', bellSchedule)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось создать расписание звонков' });
      throw error;
    });
};

export const updateBellSchedule = (id: number, bellSchedule: BellSchedule): Promise<void> => {
  return appApi
    .put(`/bell-schedules/${id}`, bellSchedule)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось обновить расписание звонков' });
      throw error;
    });
};

export const deleteBellSchedule = (id: number): Promise<void> => {
  return appApi
    .delete(`/bell-schedules/${id}`)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось удалить расписание звонков' });
      throw error;
    });
};

export const applyBellSchedule = (id: number): Promise<void> => {
  return appApi
    .post(`/bell-schedules/${id}/apply`)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось применить расписание звонков' });
      throw error;
    });
};

export const getCurrentBellSchedule = (): Promise<BellSchedule> => {
  return appApi
    .get(`/bell-schedules/current`)
    .then((res) => res.data)
    .catch((error) => {
      notification.error({ message: 'Не удалось загрузить текущее расписание звонков' });
      throw error;
    });
};
